export default {
    type: 'date',
    format: {},
    default: {
        logic: 'min',
        period: 'day'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'rolling'],
        period: ['day', 'week', 'month', 'year']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Date Added to Collection',
        category: ['User', 'Collection'],
        description: 'When the game was added to the collection.',
        summarise: {
            prefix: 'Added to collection'
        },
        unit: function(rule) {

            return rule.setting.period

        }
    }
}